const LOGIN = {
	DASHBOARD: "Portal do professor",
	DESCRIPTION: "O Aluno Presente facilita seu controle de frequência e reúne em um só lugar tudo sobre a participação dos seus alunos.",
	DO_LOGIN: "Faça seu login",
	EMAIL: "E-mail",
	FORGOT_PASSWORD: "Esqueci minha senha",
	PASSWORD: "Senha",
	EMAIL_PLACEHOLDER: "professor@id.uff.br",
	PASSWORD_PLACEHOLDER: "Professor123",
	NEW_HERE: "Não tem uma conta?",
	REGISTER: "Cadastre-se!",
	LOGIN_BTN: "Entrar",
};

export default LOGIN;